module.exports = __webpack_public_path__ + "img/TopBanner.d67f3723.png";